import styled from 'styled-components';

import Typography from 'ravenjs/lib/Typography';

const TermsAndConditionsStyled = styled(Typography)`
    padding: 5rem 0;
    width: 100%;
    font-size: 16px !important;
    font-weight: bold !important;
`;

export default TermsAndConditionsStyled;
